export default __webpack_public_path__ + "static/banner-oration-e002762d5cf587e8e37010b4464bc589.png";